import { render, staticRenderFns } from "./RoundInfo.vue?vue&type=template&id=d4cb86d2&scoped=true&"
import script from "./RoundInfo.vue?vue&type=script&lang=js&"
export * from "./RoundInfo.vue?vue&type=script&lang=js&"
import style0 from "./RoundInfo.vue?vue&type=style&index=0&id=d4cb86d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cb86d2",
  null
  
)

export default component.exports